// Models
import { StringViewModel } from '../models/string-view.model';

export namespace StringActions {
	export class GetAll {
		static readonly type = '[String] Get Strings';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[String] Set Strings';
		constructor(public strings: StringViewModel[]) {}
	}

	export class Create {
		static readonly type = '[String] Create String';
		constructor(public data: { string: StringViewModel; showSpinner?: boolean; showToast?: boolean } = { string: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateSuccess {
		static readonly type = '[String] Create String Success';
		constructor(public string: StringViewModel) {}
	}

	export class CreateError {
		static readonly type = '[String] Create String Error';
	}

	export class Update {
		static readonly type = '[String] Update String';
		constructor(public data: { string: StringViewModel; showSpinner?: boolean; showToast?: boolean } = { string: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateSuccess {
		static readonly type = '[String] Update String Success';
		constructor(public string: StringViewModel) {}
	}

	export class UpdateError {
		static readonly type = '[String] Update String Error';
	}

	export class Delete {
		static readonly type = '[String] Delete String';
		constructor(public data: { id: number; showSpinner?: boolean; showToast?: boolean; showConfirm: boolean } = { id: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}
}
